module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "aria-label": "xi",
      "id": "pg_xi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_the",
      "id": "the",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REE")])])])])])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/pgxi.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-267a28ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/map.vue
// module id = 75
// module chunks = 0